import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "adminContainer"
}
const _hoisted_2 = { class: "adminSidebar" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 1,
  class: "frontContainer"
}
const _hoisted_5 = {
  class: "frontHeader",
  style: {"position":"sticky","top":"0","z-index":"99"}
}
const _hoisted_6 = {
  class: "frontHeaderMobile",
  style: {"position":"sticky","top":"0","z-index":"99"}
}
const _hoisted_7 = {
  key: 0,
  class: "body-content"
}
const _hoisted_8 = {
  key: 0,
  class: "frontFooter"
}
const _hoisted_9 = {
  key: 1,
  class: "gridWithoutSidebar"
}
const _hoisted_10 = { class: "body" }
const _hoisted_11 = {
  key: 0,
  class: "frontFooter"
}
const _hoisted_12 = {
  key: 2,
  class: "cookie-notice"
}
const _hoisted_13 = { class: "cookie-content" }
const _hoisted_14 = { class: "cookie-text" }
const _hoisted_15 = {
  href: "https://dart-ddu.dk/ddu/persondataforordning/",
  class: "privacy-link"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_17 = { class: "cookie-actions" }

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { admZubPth } from '@/components/Utility/aXdYmZ'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const showCookieNotice = ref(true)
const languageValue = ref(1)

function noSidebar (routeName: string | null | undefined): boolean {
  return routeName === 'theClub' || routeName === 'Statistics' || routeName === 'TournamentMatchBoard'
}

function noHeader (routeName: string | null | undefined): boolean {
  return routeName === 'TournamentMatchBoard'
}

function rtPthAdmEval (inVal: any): boolean {
  const adminPath = admZubPth.toString()
  return inVal.toString().includes(`/${adminPath}`)
}

function acceptCookies (): void {
  localStorage.setItem('cookieAcceptedDate', new Date().toISOString())
  showCookieNotice.value = false
}

function shouldShowCookieNotice (): boolean {
  const cookieAcceptedDate = localStorage.getItem('cookieAcceptedDate')
  if (!cookieAcceptedDate) return true

  const acceptedDate = new Date(cookieAcceptedDate)
  const currentDate = new Date()

  acceptedDate.setHours(0, 0, 0, 0)
  currentDate.setHours(0, 0, 0, 0)

  const daysDifference = Math.floor(
    (currentDate.getTime() - acceptedDate.getTime()) / (1000 * 60 * 60 * 24)
  )

  return daysDifference >= 30
}

onMounted(() => {
  showCookieNotice.value = shouldShowCookieNotice()
})

return (_ctx: any,_cache: any) => {
  const _component_admin_sidebar = _resolveComponent("admin-sidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_front_header = _resolveComponent("front-header")!
  const _component_mobileSidebar = _resolveComponent("mobileSidebar")!
  const _component_front_footer = _resolveComponent("front-footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (rtPthAdmEval(_unref(route).path))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_admin_sidebar)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_view)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_front_header)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_mobileSidebar)
          ]),
          (!noSidebar(_unref(route).name))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_router_view),
                (!noHeader(_unref(route).name))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_front_footer)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_router_view)
                ]),
                (!noHeader(_unref(route).name))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_front_footer)
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])),
    (showCookieNotice.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, [
              _createTextVNode(_toDisplayString(languageValue.value === 1
            ? 'By clicking "Accept", you agree DDU can use cookies to enhance your experience'
            : 'Ved at klikke "Acceptér" accepterer du, at DDU kan bruge cookies til at forbedre din oplevelse') + " ", 1),
              _createElementVNode("a", _hoisted_15, _toDisplayString(languageValue.value === 1 ? 'Privacy Policy' : 'Privatlivspolitik'), 1),
              _hoisted_16
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                onClick: acceptCookies,
                class: "cookie-button accept-button"
              }, _toDisplayString(languageValue.value === 1 ? 'Accept' : 'Acceptér'), 1),
              _createElementVNode("button", {
                onClick: acceptCookies,
                class: "cookie-button reject-button"
              }, _toDisplayString(languageValue.value === 1 ? 'Reject' : 'Afvis'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})